import { Injectable, computed, signal } from '@angular/core';

import { CurrentUser } from '../interfaces/auth.type';

/**
 * Owns the current signed-in user's detail and role, in memory only.
 * Not persisted to localStorage - only the session token survives a refresh (see AuthService),
 * and AuthService.loadCurrentUser() re-derives this from that token on app start.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private readonly user = signal<CurrentUser | null>(null);

  readonly currentUser = this.user.asReadonly();
  readonly isAuthenticated = computed(() => this.user() !== null);
  readonly role = computed(() => this.user()?.role ?? 'user');

  hasRole(allowedRoles: string[]): boolean {
    return allowedRoles.includes(this.role());
  }

  setCurrentUser(user: CurrentUser): void {
    this.user.set(user);
  }

  clearCurrentUser(): void {
    this.user.set(null);
  }
}
